export const public_key = '-----BEGIN RSA PUBLIC KEY-----\n' +
'MIGJAoGBAMTWbliNYIT1tQNQe+CNomoLVhg32axM6v9H0/PhAj16VhrjhbAprr8+\n' +
'QunkN388tTe0nMBfQrJEEU8dZtas0VryWrzD0DmWFAlxVtJwVEQ1tVc61CQQ2CCl\n' +
'JGH/VMJ1nb19wcZHCHHAQoj+3nCIh0A+YDKSZhm7EWFNHOxs1AkPAgMBAAE=\n' +
'-----END RSA PUBLIC KEY-----';
export const url_public_key = 'E3sENLgs9Sxwzbkd';
export const crypto_public_key = 'abcdefghijklmnop';

